import { render, staticRenderFns } from "./HiddenText.htm?vue&type=template&id=4533e818&scoped=true&"
import script from "./HiddenText.js?vue&type=script&lang=js&"
export * from "./HiddenText.js?vue&type=script&lang=js&"
import style0 from "./HiddenText.scss?vue&type=style&index=0&id=4533e818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533e818",
  null
  
)

export default component.exports